(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
const initMastonerSearchFallback = () => {
  const fallback = document.querySelector('[data-mastoner-search-fallback]');
  if (!fallback || !window.theme || !theme.routes || !theme.routes.predictiveSearch) return;

  const query = (fallback.dataset.query || '').trim();
  const nativeResults = Number(fallback.dataset.nativeResults || 0);
  const status = fallback.querySelector('[data-mastoner-search-fallback-status]');
  const results = fallback.querySelector('[data-mastoner-search-fallback-results]');
  const emptyMessage = document.querySelector('[data-mastoner-search-empty-message]');
  if (!query || !status || !results) return;

  const searchFields = 'title,product_type,variants.title,vendor,body,variants.barcode,variants.sku,tag';
  const limit = Math.max(Number(theme.settings && theme.settings.pSearchLimit) || 10, 10);
  const productsByUrl = new Map();
  const existingUrls = new Set();
  const referenceQuery = normalizeReference(query);
  const isReferenceSearch = isReferenceSearchTerm(query);

  const showNativeEmptyState = () => {
    fallback.hidden = true;
    if (emptyMessage) emptyMessage.hidden = false;
  };
  if (nativeResults === 0 && emptyMessage) emptyMessage.hidden = true;

  const normalizeUrl = (url) => {
    try {
      return new URL(url, window.location.origin).pathname.replace(/\/$/, '');
    } catch (error) {
      return String(url || '').split('?')[0].replace(/\/$/, '');
    }
  };

  function normalizeReference(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-zA-Z0-9]/g, '')
      .toUpperCase();
  }

  function isReferenceSearchTerm(value) {
    const normalized = String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
    const compact = normalizeReference(normalized);
    const compactWithoutBrand = compact.replace(/^(HP|BROTHER|CANON|EPSON|LEXMARK|XEROX|OKI|KYOCERA|PANTUM|RICOH|SAMSUNG)/, '');
    const knownConsumableReference = /^(TN|DR|LC|PG|PGI|CLI|CL|CE|CF|CB|CC|Q|C|W|CN|CH|C13|T)\d{2,}[A-Z0-9]*$/.test(compact);
    const shortNumericReference = /^\d{3,5}[A-Z]{0,4}$/.test(compactWithoutBrand);

    return /^\d{8,14}$/.test(compact) || knownConsumableReference || shortNumericReference;
  }

  function referenceTokenMatches(token, reference) {
    if (!token || !reference) return false;
    if (/^\d+$/.test(reference)) return token.includes(reference);
    if (token === reference) return true;

    // Allows pack or format extensions such as TN2420TWIN, but not adjacent refs like TN242Y or TN2410.
    return /\d$/.test(reference) && token.startsWith(reference);
  }

  function linkMatchesReference(link) {
    if (!isReferenceSearch || !referenceQuery) return true;

    const text = [
      link.innerText || link.textContent || '',
      link.getAttribute('href') || ''
    ].join(' ');
    const tokens = (text.match(/[a-zA-Z0-9][a-zA-Z0-9\-_/.,:;]*/g) || [])
      .map(normalizeReference)
      .filter(Boolean);

    return tokens.some((token) => referenceTokenMatches(token, referenceQuery));
  }

  function hideNativeSearchResults() {
    const container = fallback.parentElement;
    if (!container) return;

    Array.from(container.children).forEach((element) => {
      if (element === fallback) return;
      if (element.matches('ul.grid, nav') || element.querySelector('.js-pagination')) {
        element.hidden = true;
      }
    });
  }

  document.querySelectorAll('.main-products-grid__results .js-prod-link[href*="/products/"], .main-products-grid__results .card-link[href*="/products/"]').forEach((link) => {
    existingUrls.add(normalizeUrl(link.getAttribute('href')));
  });

  const addCandidate = (candidates, candidate) => {
    const value = String(candidate || '').replace(/\s+/g, ' ').trim();
    if (value.length >= 2 && !candidates.includes(value)) candidates.push(value);
  };

  const addConsumableReferenceCandidates = (reference, candidates) => {
    ['CE', 'CF', 'CB', 'CC', 'Q', 'C', 'W', 'CN', 'CH', 'PG', 'CL', 'LC', 'TN', 'DR'].forEach((prefix) => {
      addCandidate(candidates, `${prefix}${reference}`);
      addCandidate(candidates, `${prefix}-${reference}`);
    });

    if (/^\d{3,5}[A-Z]{1,3}$/.test(reference)) {
      const trimmedReference = reference.substring(1);
      addCandidate(candidates, trimmedReference);
      addCandidate(candidates, `HP ${trimmedReference}`);
      addCandidate(candidates, `HP ${reference}`);
      addCandidate(candidates, `Toner ${trimmedReference}`);
      addCandidate(candidates, `Toner ${reference}`);
    }
  };

  const addNumericConsumableReferenceCandidates = (reference, candidates) => {
    ['CE', 'CF', 'CB', 'CC', 'Q', 'C', 'W'].forEach((prefix) => {
      addCandidate(candidates, `${prefix}${reference}A`);
      addCandidate(candidates, `${prefix}-${reference}A`);
    });

    ['TN', 'DR', 'LC', 'PG', 'CL'].forEach((prefix) => {
      addCandidate(candidates, `${prefix}${reference}`);
      addCandidate(candidates, `${prefix}-${reference}`);
    });
  };

  const addSpanishAccentCandidates = (normalizedSearch, candidates) => {
    const accentPairs = [
      ['toner', 't\u00f3ner'],
      ['toners', 't\u00f3ners'],
      ['laser', 'l\u00e1ser'],
      ['impresion', 'impresi\u00f3n'],
      ['multifuncion', 'multifunci\u00f3n'],
      ['inyeccion', 'inyecci\u00f3n'],
      ['termica', 't\u00e9rmica'],
      ['termico', 't\u00e9rmico'],
      ['escaner', 'esc\u00e1ner'],
      ['escaneres', 'esc\u00e1neres'],
      ['informatica', 'inform\u00e1tica'],
      ['papeleria', 'papeler\u00eda'],
      ['portatil', 'port\u00e1til'],
      ['portatiles', 'port\u00e1tiles'],
      ['conexion', 'conexi\u00f3n'],
      ['alimentacion', 'alimentaci\u00f3n'],
      ['proteccion', 'protecci\u00f3n'],
      ['lamina', 'l\u00e1mina'],
      ['laminas', 'l\u00e1minas'],
      ['telefono', 'tel\u00e9fono']
    ];
    const variants = new Set([normalizedSearch]);

    accentPairs.forEach(([plain, accented]) => {
      Array.from(variants).forEach((variant) => {
        const expression = new RegExp(`\\b${plain}\\b`, 'g');
        if (expression.test(variant)) variants.add(variant.replace(expression, accented));
      });
    });

    variants.forEach((variant) => addCandidate(candidates, variant));
  };

  const getSearchCandidates = (searchTerm) => {
    const candidates = [];
    const compact = searchTerm.replace(/[\s\-_/.,:;]+/g, '');
    const compactReference = compact.toUpperCase();
    const spaced = searchTerm.replace(/[\-_/.,:;]+/g, ' ');
    const spacedReference = compact
      .replace(/([a-zA-Z]+)(\d+)/g, '$1 $2')
      .replace(/(\d+)([a-zA-Z]+)/g, '$1 $2');
    const hyphenReference = compact.replace(/^([a-zA-Z]{1,6})(\d.*)$/g, '$1-$2');
    const normalizedSearch = spaced
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
    const normalizedCompact = compact
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();

    if (/^\d{2,5}[A-Z]{1,3}$/.test(compactReference)) {
      addConsumableReferenceCandidates(compactReference, candidates);
    }

    if (/^\d{3,5}$/.test(compactReference)) {
      addNumericConsumableReferenceCandidates(compactReference, candidates);
    }

    addCandidate(candidates, searchTerm);
    addCandidate(candidates, spaced);
    addCandidate(candidates, compact);
    addCandidate(candidates, spacedReference);
    addCandidate(candidates, hyphenReference);
    addSpanishAccentCandidates(normalizedSearch, candidates);

    if (/^porta/.test(normalizedCompact)
      || /\bordenadores?\s+portatiles?\b/.test(normalizedSearch)
      || /\b(laptops?|notebooks?|portatiles?)\b/.test(normalizedSearch)) {
      addCandidate(candidates, 'portatil');
      addCandidate(candidates, 'portátil');
      addCandidate(candidates, 'portatiles');
      addCandidate(candidates, 'portátiles');
      addCandidate(candidates, 'ordenador portatil');
      addCandidate(candidates, 'ordenador portátil');
      addCandidate(candidates, 'ordenadores portatiles');
      addCandidate(candidates, 'ordenadores portátiles');
      addCandidate(candidates, 'laptop');
      addCandidate(candidates, 'notebook');
    }

    return candidates;
  };

  const fallbackRequestTimeoutMs = 5000;

  const fetchPredictiveResults = async (candidate) => {
    const params = new URLSearchParams();
    params.set('q', candidate);
    params.set('resources[type]', 'product');
    params.set('resources[limit]', String(limit));
    params.set('resources[limit_scope]', 'each');
    params.set('resources[options][unavailable_products]', 'last');
    params.set('resources[options][fields]', searchFields);
    params.set('section_id', 'predictive-search');

    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), fallbackRequestTimeoutMs);
    try {
      const response = await fetch(`${theme.routes.predictiveSearch}?${params.toString()}`, {
        signal: controller.signal
      });
      if (!response.ok) throw new Error(`Predictive search failed with ${response.status}.`);

      const template = document.createElement('template');
      template.innerHTML = await response.text();
      template.content.querySelectorAll('[id$="-products"] .predictive-search__item:not(.js-submit) .predictive-result').forEach((link) => {
        const url = link.getAttribute('href');
        const normalizedUrl = normalizeUrl(url);
        const alreadyInNativeResults = existingUrls.has(normalizedUrl);
        if (url && normalizedUrl && linkMatchesReference(link) && (isReferenceSearch || !alreadyInNativeResults) && !productsByUrl.has(normalizedUrl)) {
          productsByUrl.set(normalizedUrl, link);
        }
      });
      return true;
    } finally {
      window.clearTimeout(timeout);
    }
  };

  const renderResults = () => {
    if (!productsByUrl.size) {
      showNativeEmptyState();
      return;
    }

    fallback.hidden = false;
    if (emptyMessage) emptyMessage.hidden = true;
    if (isReferenceSearch) {
      hideNativeSearchResults();
      status.textContent = `Coincidencias exactas para "${query}"`;
    } else {
      status.textContent = nativeResults > 0
        ? `Coincidencias relacionadas para "${query}"`
        : `Coincidencias encontradas para "${query}"`;
    }

    productsByUrl.forEach((link) => {
      const item = document.createElement('li');
      item.className = 'mastoner-search-fallback__item';
      item.appendChild(link.cloneNode(true));
      results.appendChild(item);
    });
  };

  const searchCandidates = getSearchCandidates(query);
  Promise.allSettled(searchCandidates.map(fetchPredictiveResults))
    .then((outcomes) => {
      const anySuccessfulRequest = outcomes.some((outcome) => outcome.status === 'fulfilled' && outcome.value === true);
      if (anySuccessfulRequest) {
        renderResults();
      } else {
        showNativeEmptyState();
      }
    })
    .catch(() => {
      showNativeEmptyState();
    });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMastonerSearchFallback);
} else {
  initMastonerSearchFallback();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mastoner-associated-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mastoner-associated-products-list')) {
  class MastonerAssociatedProductsList extends HTMLElement {
    connectedCallback() {
      if (this.dataset.showMoreReady === 'true') return;

      const grid = this.querySelector('[data-associated-products-grid]');
      const toggle = this.querySelector('[data-associated-products-toggle]');
      if (!grid || !toggle) return;

      const parsedInitialCount = Number.parseInt(this.dataset.initialCount, 10);
      const initialCount = Number.isFinite(parsedInitialCount) ? Math.max(1, parsedInitialCount) : 8;
      const cards = Array.from(grid.children).filter((item) => item.classList.contains('mastoner-associated__card'));
      const extraCards = cards.slice(initialCount);

      if (extraCards.length === 0) return;

      this.dataset.showMoreReady = 'true';
      extraCards.forEach((card) => {
        card.hidden = true;
      });

      const label = toggle.querySelector('[data-associated-products-label]');
      const count = toggle.querySelector('[data-associated-products-count]');
      if (count) count.textContent = ` (${extraCards.length})`;

      toggle.hidden = false;
      toggle.addEventListener('click', (event) => {
        const willExpand = toggle.getAttribute('aria-expanded') !== 'true';

        extraCards.forEach((card) => {
          card.hidden = !willExpand;
        });

        toggle.setAttribute('aria-expanded', String(willExpand));
        if (label) label.textContent = willExpand ? toggle.dataset.lessLabel : toggle.dataset.moreLabel;
        if (count) count.hidden = willExpand;

        if (willExpand && event.detail === 0) {
          const firstRevealedLink = extraCards[0].querySelector('.mastoner-associated__title');
          if (firstRevealedLink) firstRevealedLink.focus();
        }
      });
    }
  }

  customElements.define('mastoner-associated-products-list', MastonerAssociatedProductsList);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mastoner-hp-consumables"] && !Shopify.designMode) return;
  try {
    
  function mastonerHpInit(scope) {
    const roots = scope.matches && scope.matches('[data-mhp]') ? [scope] : scope.querySelectorAll('[data-mhp]');
    roots.forEach(root => {
      if (root.dataset.mhpReady === 'true') return;
      root.dataset.mhpReady = 'true';
      const search = root.querySelector('[data-mhp-search]');
      const cards = Array.from(root.querySelectorAll('[data-mhp-model]'));
      const count = root.querySelector('[data-mhp-count]');
      const empty = root.querySelector('[data-mhp-empty]');
      const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
      if (search && cards.length && count && empty) {
        const filter = () => {
          const query = normalize(search.value);
          let total = 0;
          cards.forEach(card => {
            const names = [card.dataset.mhpLabel, ...(card.dataset.mhpAliases || '').split(',')];
            const visible = names.some(name => normalize(name).includes(query));
            card.hidden = !visible;
            if (visible) total += 1;
          });
          count.textContent = total === 1 ? '1 modelo encontrado' : total + ' modelos encontrados';
          empty.hidden = total > 0;
        };
        search.addEventListener('input', filter);
        root.querySelector('[data-mhp-finder]').hidden = false;
        count.hidden = false;
        filter();
      }
      const groups = Array.from(root.querySelectorAll('[data-mhp-paper-group]'));
      const buttons = Array.from(root.querySelectorAll('[data-mhp-width]'));
      const control = root.querySelector('[data-mhp-width-control]');
      const status = root.querySelector('[data-mhp-width-status]');
      if (groups.length && buttons.length && control && status) {
        const selectWidth = selected => {
          buttons.forEach(item => item.setAttribute('aria-pressed', String(item.dataset.mhpWidth === selected)));
          groups.forEach(group => { group.hidden = group.dataset.mhpPaperGroup !== selected; });
          const active = groups.find(group => group.dataset.mhpPaperGroup === selected);
          const total = active ? active.querySelectorAll('[data-mhp-paper-product]').length : 0;
          status.textContent = total + (total === 1 ? ' bobina para tu plotter de ' : ' bobinas para tu plotter de ') + selected + ' pulgadas.';
        };
        buttons.forEach(button => button.addEventListener('click', () => selectWidth(button.dataset.mhpWidth)));
        const firstAvailable = groups.find(group => group.querySelectorAll('[data-mhp-paper-product]').length > 0) || groups[0];
        selectWidth(firstAvailable.dataset.mhpPaperGroup);
        control.hidden = false;
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mastonerHpInit(document), { once: true });
  else mastonerHpInit(document);
  document.addEventListener('shopify:section:load', event => mastonerHpInit(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mastoner-printer-groups"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mastoner-associated-products-group')) {
  class MastonerAssociatedProductsGroup extends HTMLElement {
    static normalize(value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toUpperCase()
        .trim();
    }

    static naturalCompare(left, right) {
      return String(left).localeCompare(String(right), 'es', { numeric: true, sensitivity: 'base' });
    }

    connectedCallback() {
      if (this.dataset.showMoreReady === 'true') return;

      const grid = this.querySelector('[data-associated-products-grid]');
      const toggle = this.querySelector('[data-associated-products-toggle]');
      if (!grid || !toggle) return;

      const parsedInitialCount = Number.parseInt(this.dataset.initialCount, 10);
      const initialCount = Number.isFinite(parsedInitialCount) ? Math.max(1, parsedInitialCount) : 8;
      const cards = Array.from(grid.children).filter((item) => item.classList.contains('mastoner-plotter-associated-card'));
      const ordering = this.dataset.sortMode === 'consumables'
        ? this.organizeConsumables(cards)
        : { cards, organized: false };
      const orderedCards = ordering.cards;

      this.dataset.associatedOrder = ordering.organized ? 'family-color' : 'original';
      if (ordering.organized) grid.append(...orderedCards);

      const extraCards = orderedCards.slice(initialCount);

      if (extraCards.length === 0) return;

      this.dataset.showMoreReady = 'true';
      extraCards.forEach((card) => {
        card.hidden = true;
      });

      const label = toggle.querySelector('[data-associated-products-label]');
      const count = toggle.querySelector('[data-associated-products-count]');
      if (count) count.textContent = ` (${extraCards.length})`;

      toggle.hidden = false;
      toggle.addEventListener('click', (event) => {
        const willExpand = toggle.getAttribute('aria-expanded') !== 'true';

        extraCards.forEach((card) => {
          card.hidden = !willExpand;
        });

        toggle.setAttribute('aria-expanded', String(willExpand));
        if (label) label.textContent = willExpand ? toggle.dataset.lessLabel : toggle.dataset.moreLabel;
        if (count) count.hidden = willExpand;

        if (willExpand && event.detail === 0) {
          const firstRevealedLink = extraCards[0].querySelector('.mastoner-plotter-associated-card__title');
          if (firstRevealedLink) firstRevealedLink.focus();
        }
      });
    }

    getTags(card) {
      return String(card.dataset.associatedTags || '')
        .split('||')
        .map((tag) => MastonerAssociatedProductsGroup.normalize(tag))
        .filter(Boolean);
    }

    getKindRank(card) {
      const structuredType = MastonerAssociatedProductsGroup.normalize(card.dataset.associatedProductType);
      const title = MastonerAssociatedProductsGroup.normalize(card.dataset.associatedTitle);
      const tags = this.getTags(card);
      const signals = `${structuredType} ${title} ${tags.join(' ')}`;

      if (tags.includes('MF-CONSUMABLE-DEPOSITO-RESIDUOS') || /DEPOSITO.*RESIDU|RESIDU.*TONER|WASTE/.test(signals)) return 30;
      if (tags.includes('MF-CONSUMABLE-TAMBOR') || /\b(TAMBOR|TAMBORES|DRUM|PHOTOCONDUCTOR)\b/.test(signals)) return 10;
      if (tags.includes('MF-CONSUMABLE-UNIDAD-TRANSFERENCIA') || /TRANSFERENCIA|CINTURON.*ARRASTRE|TRANSFER.*BELT/.test(signals)) return 20;
      if (tags.includes('MF-CONSUMABLE-FUSOR') || /\b(FUSOR|FUSER)\b/.test(signals)) return 40;
      if (tags.includes('MF-CONSUMABLE-KIT-MANTENIMIENTO') || /KIT.*MANTENIMIENTO|MAINTENANCE.*KIT/.test(signals)) return 50;
      if (tags.includes('MF-CONSUMABLE-CABEZAL') || /\b(CABEZAL|PRINTHEAD)\b/.test(signals)) return 60;

      const primaryTags = [
        'MF-CONSUMABLE-TONER',
        'MF-CONSUMABLE-TINTA',
        'MF-CONSUMABLE-CARTUCHO',
        'MF-CONSUMABLE-CINTA',
        'MF-CONSUMABLE-RIBBON',
        'MF-CONSUMABLE-ETIQUETA'
      ];
      if (primaryTags.some((tag) => tags.includes(tag))) return 0;
      if (/\b(TONER|TINTA|CARTUCHO|INK|CARTRIDGE|RIBBON|CINTA|ETIQUETA|ETIQUETADO|ROLLO)\b/.test(signals)) return 0;

      return 90;
    }

    getColor(card) {
      const structuredColor = MastonerAssociatedProductsGroup.normalize(card.dataset.associatedColor);
      const title = MastonerAssociatedProductsGroup.normalize(card.dataset.associatedTitle);
      const tags = this.getTags(card);
      const signals = [structuredColor, ...tags];
      const hasSignal = (...values) => values.some((value) => signals.includes(value));

      if (hasSignal('NEGRO', 'BLACK', 'BK', 'K', 'MF-COLOR-NEGRO', 'COLOR:NEGRO')) {
        return { key: 'K', rank: 0, hpDigit: '0', suffixes: ['BK', 'K'] };
      }
      if (hasSignal('CIAN', 'CYAN', 'C', 'MF-COLOR-CIAN', 'COLOR:CIAN')) {
        return { key: 'C', rank: 1, hpDigit: '1', suffixes: ['C'] };
      }
      if (hasSignal('MAGENTA', 'M', 'MF-COLOR-MAGENTA', 'COLOR:MAGENTA')) {
        return { key: 'M', rank: 2, hpDigit: '3', suffixes: ['M'] };
      }
      if (hasSignal('AMARILLO', 'YELLOW', 'Y', 'MF-COLOR-AMARILLO', 'COLOR:AMARILLO')) {
        return { key: 'Y', rank: 3, hpDigit: '2', suffixes: ['Y'] };
      }

      if (/\b(NEGRO|BLACK)\b/.test(title)) return { key: 'K', rank: 0, hpDigit: '0', suffixes: ['BK', 'K'] };
      if (/\b(CIAN|CYAN)\b/.test(title)) return { key: 'C', rank: 1, hpDigit: '1', suffixes: ['C'] };
      if (/\bMAGENTA\b/.test(title)) return { key: 'M', rank: 2, hpDigit: '3', suffixes: ['M'] };
      if (/\b(AMARILLO|YELLOW)\b/.test(title)) return { key: 'Y', rank: 3, hpDigit: '2', suffixes: ['Y'] };

      return null;
    }

    getOrigin(card) {
      const structuredOrigin = MastonerAssociatedProductsGroup.normalize(card.dataset.associatedOrigin);
      const vendor = MastonerAssociatedProductsGroup.normalize(card.dataset.associatedVendor);
      const title = MastonerAssociatedProductsGroup.normalize(card.dataset.associatedTitle);
      const tags = this.getTags(card);

      if (structuredOrigin === 'ORIGINAL' || tags.includes('MF-ORIGIN-ORIGINAL') || /\bORIGINAL\b/.test(title)) return 'ORIGINAL';
      if (structuredOrigin === 'COMPATIBLE' || tags.includes('MF-ORIGIN-COMPATIBLE') || vendor === 'COMPATIBLE' || /\bCOMPATIBLE\b/.test(title)) return 'COMPATIBLE';

      return null;
    }

    getFamily(card, color) {
      const rawReference = String(card.dataset.associatedReference || '').trim();
      // Multi-reference compatibles can span capacities; keep their editorial order instead of guessing.
      if (!rawReference || /[,;|/]/.test(rawReference)) return null;

      const reference = MastonerAssociatedProductsGroup.normalize(rawReference).replace(/[^A-Z0-9]/g, '');
      if (reference.length < 4 || !/\d/.test(reference)) return null;

      let family = null;
      for (const suffix of color.suffixes) {
        if (!reference.endsWith(suffix)) continue;

        const candidate = reference.slice(0, -suffix.length);
        if (candidate.length >= 3 && /\d/.test(candidate)) {
          family = candidate;
          break;
        }
      }

      if (!family) {
        const brandSignals = MastonerAssociatedProductsGroup.normalize(
          `${card.dataset.associatedVendor || ''} ${card.dataset.associatedTitle || ''}`
        );
        const hpReference = reference.match(/^([A-Z]{1,4}\d{2,})([0-3])([A-Z]{1,2})$/);
        if (/(^|\s)HP(\s|$)/.test(brandSignals) && hpReference && hpReference[2] === color.hpDigit) {
          family = `${hpReference[1]}#${hpReference[3]}`;
        }
      }

      if (!family) return null;

      let base = family;
      let capacityRank = 0;
      if (/XXL$/.test(base)) {
        base = base.slice(0, -3);
        capacityRank = 2;
      } else if (/XL$/.test(base)) {
        base = base.slice(0, -2);
        capacityRank = 1;
      } else if (/#X$/.test(base)) {
        base = base.slice(0, -1);
        capacityRank = 1;
      } else if (/#A$/.test(base)) {
        base = base.slice(0, -1);
      }

      return { key: family, base, capacityRank };
    }

    organizeConsumables(cards) {
      // Reorder only when every primary supply forms an unambiguous, complete CMYK family.
      const descriptors = cards.map((card, index) => {
        const kindRank = this.getKindRank(card);
        const color = kindRank === 0 ? this.getColor(card) : null;
        const family = color ? this.getFamily(card, color) : null;

        return {
          card,
          index,
          kindRank,
          color,
          family,
          origin: kindRank === 0 ? this.getOrigin(card) : null,
          vendor: MastonerAssociatedProductsGroup.normalize(card.dataset.associatedVendor)
        };
      });

      if (descriptors.some((descriptor) => descriptor.kindRank === 90)) return { cards, organized: false };

      const primary = descriptors.filter((descriptor) => descriptor.kindRank === 0);
      if (primary.length < 4) return { cards, organized: false };
      if (primary.some((descriptor) => !descriptor.color || !descriptor.family || !descriptor.origin)) {
        return { cards, organized: false };
      }

      const buckets = new Map();
      primary.forEach((descriptor) => {
        const key = `${descriptor.vendor}|${descriptor.origin}|${descriptor.family.key}`;
        if (!buckets.has(key)) {
          buckets.set(key, {
            firstIndex: descriptor.index,
            family: descriptor.family,
            descriptors: []
          });
        }
        buckets.get(key).descriptors.push(descriptor);
      });

      const groups = Array.from(buckets.values());
      const allGroupsComplete = groups.every((group) => {
        const colors = new Set(group.descriptors.map((descriptor) => descriptor.color.key));
        return group.descriptors.length === 4 && colors.size === 4 && ['K', 'C', 'M', 'Y'].every((color) => colors.has(color));
      });
      if (!allGroupsComplete) return { cards, organized: false };

      groups.sort((left, right) => {
        const baseComparison = MastonerAssociatedProductsGroup.naturalCompare(left.family.base, right.family.base);
        if (baseComparison !== 0) return baseComparison;
        if (left.family.capacityRank !== right.family.capacityRank) return left.family.capacityRank - right.family.capacityRank;

        const familyComparison = MastonerAssociatedProductsGroup.naturalCompare(left.family.key, right.family.key);
        if (familyComparison !== 0) return familyComparison;
        return left.firstIndex - right.firstIndex;
      });

      const orderedPrimary = groups.flatMap((group) => group.descriptors.sort((left, right) => {
        if (left.color.rank !== right.color.rank) return left.color.rank - right.color.rank;
        return left.index - right.index;
      }));
      const orderedMaintenance = descriptors
        .filter((descriptor) => descriptor.kindRank !== 0)
        .sort((left, right) => left.kindRank - right.kindRank || left.index - right.index);

      return {
        cards: [...orderedPrimary, ...orderedMaintenance].map((descriptor) => descriptor.card),
        organized: true
      };
    }
  }

  customElements.define('mastoner-associated-products-group', MastonerAssociatedProductsGroup);
}

  } catch(e) { console.error(e); }
})();
})();
